/* 🤖 this file was generated by svg-to-ts*/
export const iconFile = {
  name: 'file',
  data: `
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" >
    <g clip-path="url(#clip0_0_8)">
    <path d="M19.4533 3.45333C18.9467 2.94667 18.2667 2.66667 17.56 2.66667H8C6.53333 2.66667 5.33333 3.86667 5.33333 5.33333V26.6667C5.33333 28.1333 6.52 29.3333 7.98666 29.3333H24C25.4667 29.3333 26.6667 28.1333 26.6667 26.6667V11.7733C26.6667 11.0667 26.3867 10.3867 25.88 9.89333L19.4533 3.45333ZM20 24H12C11.2667 24 10.6667 23.4 10.6667 22.6667C10.6667 21.9333 11.2667 21.3333 12 21.3333H20C20.7333 21.3333 21.3333 21.9333 21.3333 22.6667C21.3333 23.4 20.7333 24 20 24ZM20 18.6667H12C11.2667 18.6667 10.6667 18.0667 10.6667 17.3333C10.6667 16.6 11.2667 16 12 16H20C20.7333 16 21.3333 16.6 21.3333 17.3333C21.3333 18.0667 20.7333 18.6667 20 18.6667ZM17.3333 10.6667V4.66667L24.6667 12H18.6667C17.9333 12 17.3333 11.4 17.3333 10.6667Z" />
    </g>
    <defs>
    <clipPath id="clip0_0_8">
    <rect width="32" height="32" fill="white"/>
    </clipPath>
    </defs>
  </svg>
`,
}
